import React, { Component } from 'react'
import BookingInput from '../Booking/bookinginput';
import formhoc from './formhoc';
import { becomeapartner_api } from '../../actions/http';
import ButtonLoader from '../btnloader';
import {Helmet} from "react-helmet";


class BecomePartner extends Component {
    render() {
        const {ipState, onChange, formFilled} = this.props;
        const { name, name_err,location,phone_number, phone_number_err,email_id,email_id_err,business_type,business_type_err, form_fetching } = ipState;
        return (
            
            <div>
                <Helmet>
                    <meta name="description" content="We’d love to discuss how partnering with Ouja can generate awareness and drive leads for your business. Generate demand and quality service with Ouja."/>
                    <title>Partner with Ouja |  Become a Partner | Partnership Enquiry</title>
                    <meta name="keywords" content="Partner"/>
                </Helmet>
                <h3 className="f-600 m-b-20 m-t-20">Become a Partner</h3>
                <div className="row">
                    <BookingInput 
                        size={12} 
                        type="text"
                        name="name"
                        onChange={onChange}
                        placeholder="Name" 
                        value={name}
                        err={name_err}
                    />
                    <BookingInput 
                        size={12} 
                        type="number"
                        name="phone_number"
                        placeholder="Phone Number" 
                        maxLength={10}
                        onChange={onChange}
                        value={phone_number}
                        err={phone_number_err}
                    />

                    <BookingInput 
                        size={12} 
                        type="text"
                        name="email_id"
                        placeholder="Email Id" 
                        
                        onChange={onChange}
                        value={email_id}
                        err={email_id_err}
                    />
                    <BookingInput 
                        size={12} 
                        type="text"
                        name="business_type"
                        placeholder="Business Type" 
                        
                        onChange={onChange}
                        value={business_type}
                        err={business_type_err}
                    />
                    
                    
                    <div className="col-md-12">
                        <select value={location} onChange={onChange} name="location" className="form-control input-md">
                            <option value="Chennai">Chennai</option>
                            <option value="Coimbatore">Coimbatore</option>
                            <option value="Neyveli">Neyveli</option>
                           
                        </select>
                    </div>
                    <div className="col-md-12">
                        <button disabled={formFilled && !form_fetching ? false : true} type="submit" className="btn m-t-10 btn-block btn-ouja">{ form_fetching ? <ButtonLoader /> : 'Submit' }</button>
                    </div>
                </div>
            </div>
           
        )
    }
}

const inputs = [
    {
        name: "name"
    },
    {
        name: "phone_number",
        validate: {type: "PHONE_NUMBER"}
    },
    {
        name: "email_id"
        
    },
    {
        name: "business_type"
        
    },
    
    {
        name: "location",
        defaultValue: "Chennai"
    },
    {
        name: "type",
        defaultValue: 2
    }
];

const formConfig = {
    url: becomeapartner_api,
    method: "POST" 
};

export default formhoc(BecomePartner, inputs, formConfig);
